import { render, staticRenderFns } from "./ResourceDetailSkeleton.vue?vue&type=template&id=de2d16a0&scoped=true"
import script from "./ResourceDetailSkeleton.vue?vue&type=script&lang=js"
export * from "./ResourceDetailSkeleton.vue?vue&type=script&lang=js"
import style0 from "./ResourceDetailSkeleton.vue?vue&type=style&index=0&id=de2d16a0&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "de2d16a0",
  null
  
)

export default component.exports